import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import AutoFilters from 'components/AutoFilters';
import useIsMobile from 'hooks/useIsMobile';
import { Airport } from 'models/airport';
import { VehicleFilterResponse } from 'models/auto/vehicleFilter';
import { VehicleResultsFilters } from 'models/auto/vehicleResults';
import { VehiclePlace } from 'models/auto/vehicleSearch';
import { City } from 'models/city';

interface Props {
  show: boolean;
  onClose: () => void;
  onChange: (payload: VehicleResultsFilters) => void;
  availableFilters?: VehicleFilterResponse;
  days?: number;
  isLoading: boolean;
  pickUpPoint?: Airport | City | VehiclePlace;
  dropOffPoint?: Airport | City | VehiclePlace;
  pickUpDate?: Date;
  dropOffDate?: Date;
}

const AutosFilterContainer = ({
  onChange,
  availableFilters,
  isLoading,
  pickUpPoint,
  dropOffPoint,
  pickUpDate,
  dropOffDate,
  ...props
}: Props) => {
  const isMobile = useIsMobile();
  const { defaultFilters, country } = useSelector((state: RootState) => ({
    defaultFilters: state.autos.filters ? state.autos.filters : undefined,
    country: state.i18n.country,
  }));

  const handleSearch = async (payload: VehicleResultsFilters) => {
    if (isMobile) props.onClose();
    onChange(payload);
  };

  return (
    <AutoFilters
      {...props}
      onSearch={handleSearch}
      defaultFilters={defaultFilters}
      currency={country.currency as string}
      availableFilters={availableFilters}
      isLoading={isLoading}
      pickUpDate={pickUpDate}
      dropOffDate={dropOffDate}
      pickUpPoint={pickUpPoint}
      dropOffPoint={dropOffPoint}
    />
  );
};

export default AutosFilterContainer;
